import { createContext, useContext } from 'react';

type JonumRewardGateContext = {
  openJonumRewardGate: () => boolean;
};

export const JonumRewardGateContext =
  createContext<JonumRewardGateContext | null>(null);

export const useJonumRewardGateContext = () =>
  useContext(JonumRewardGateContext);
